export const RETRY_MESSAGE = 'Reconectando, aguarde...';

let _message = null;
const _listeners = new Set();

export function setRetryMessage(message) {
  _message = message;
  _listeners.forEach(fn => fn(message));
}

export function getRetryMessage() {
  return _message;
}

export function subscribeRetryMessage(callback) {
  _listeners.add(callback);
  return () => _listeners.delete(callback);
}
